<template>
  <div class="white ma-2 px-7 py-5 d-flex flex-column text-center rounded-lg">
    <div class="text-center" style="line-height: 1.2 !important">
      <h2 class="mb-3">Welcome {{ pro.business_name }}!</h2>
      Create your Referra account and start growing your business today
      with leads from partners you already trust.
    </div>
    
    <div class="mt-4 primary--text" v-if="pro.lead_count > 0">
      <h2 v-if="pro.lead_count == 1">You have a lead waiting!</h2>
      <h2 v-else>You have {{ pro.lead_count }} leads waiting!</h2>
    </div>

    <div class="mt-4" v-if="pro.accounts.length > 0" style="line-height: 1.2 !important">
      <h3 class="mb-3">These businesses already want to partner with you:</h3>
      <div v-for="account in pro.accounts" :key="account.account_id">
        {{ account.account_name }}
      </div>
    </div>
    
    <div class="mt-6 mb-3 d-flex justify-center">
      <v-btn width="60%" type="submit" color="primary" @click="verifyClick">
        Claim this Account
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProInviteUnclaimed',

  props: ['pro'],

  methods: {
    verifyClick() {
      this.$router.push({ name: 'new/pro/create' })
    },
  },
}
</script>